import Alpine from "alpinejs";
import reportPage from "./reportPage";

// suggested in the Alpine docs:
// make Alpine on window available for better DX
window.Alpine = Alpine;

Alpine.data("reportPage", reportPage);
Alpine.start();
